<template>
  <v-select
      v-model="innerModel"
      :disabled="disabled"
      :item-text="itemText"
      :item-value="itemValue"
      :items="items"
      :label="label"
      :clearable="clearable"
      dense
      outlined
      hide-details
      :error="error"
  />
</template>

<script>
export default {
  /**
   * SingleSelectBox.vue 컴포넌트
   * 복사해서 만든 컴포넌트
   */
  name: "SelectBoxSingleCheck",
  props: {
    value: undefined,
    items: Array,
    label: {
      type: String,
      default: "Select Items",
    },
    itemValue: {
      type: String,
      default: "codeKey"
    },
    itemText: {
      type: String,
      default: "codeValue"
    },
    disabled: {
      type: Boolean,
      default: false,
    },
      error:{
          type: Boolean,
          default: false,
      },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      innerModel: null,
    }
  },
  watch: {
    innerModel(newValue, oldValue) {
      if (this.checkDirty(newValue, oldValue) !== true) return;
      this.$emit('input', newValue);
      this.$emit('update:selected',this.label);
    },
    value: {
      immediate: true,
      handler(newValue,oldValue)  {
        if (this.checkDirty(newValue, oldValue) !== true) return;//X 버튼 눌렀을때 data값 초기화
        this.innerModel = newValue;
      }
    },
  },
  methods: {
    /**
     * 처음 값이 없거나(첫 랜더링시), 나중 값이 없을때(X버튼을 눌렀을때)
     * @param newValue
     * @param oldValue
     * @returns {boolean}
     */
    checkDirty(newValue, oldValue) {
      if (newValue === undefined && oldValue !== undefined) return true;
      if (newValue === oldValue) return false;
      //if (this.items.filter(e => e[this.itemValue] === newValue).length < 1) return false;
      return true;
    },
  },
}
</script>

<style scoped>
>>> input:read-only, >>> input {
  background-color: transparent !important;
  border: 0 !important;
}



</style>
